import { Button } from "@/react/components/shared/uikit/Button";
import { Typography } from "@/react/components/shared/uikit/Typography";

interface CtaButtonProps {
  label: string;
  onClick: () => void;
}

export const CtaButton = ({ label, onClick }: CtaButtonProps) => (
  <Button type="button" variant="circle" onClick={onClick}>
    <Typography.LabelSm weight="medium" color="text-inverse">
      {label}
    </Typography.LabelSm>
  </Button>
);
